<template>
    <b-col sm="12" md="2">
        <b-card>
            <div :class="`h1 text-right mb-3`" :style="{ color: color }">
                <!-- <i class="icon-people"></i> -->
                <i :class="`fa ${icon} fa-2x`"></i>
            </div>
            <div class="h1 mb-0">
                <i v-if="loading" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                <!-- <span v-if="!loading && padrao">{{ qtd }}</span> -->
                <slot>
                    <span v-if="!loading">{{ qtd }}</span>
                </slot>
            </div>
            <!-- <small class="text-muted text-uppercase font-weight-bold">{{ titulo }}</!-->
            <span class="text-dark text-uppercase font-weight-bold">{{ titulo }}</span>
            <!-- <b-progress height="{}" class="progress-xs mt-3 mb-0" variant="info" :value="25" /> -->
        </b-card>
    </b-col>
</template>

<script>
export default {
	props: {
		icon: {
			type: String
		},

		titulo: {
			type: String
		},

		qtd: {
			type: Number,
			default: 0
		},

		loading: {
			type: Boolean,
			default: () => false
		},

		color: {
			type: String,
			default: () => 'gray'
		}
	},

	data() {
		return {
			isHovering: false
		}
	}
}
</script>
